<section *ngIf="canjeMedicos" class="card">
    <h2 style="text-align: center;">Notificaciones de canje de Medicos</h2>
    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>
        </ng-template>

    </p-toolbar>
    <p-table [value]="paginacionCanjesMedicos" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Fecha</th>
                <th>Medico</th>
                <th>Estatus</th>
                <th>Redimir</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-canje>
            <tr>
                <td>{{canje.fechaInicio | date:'dd/MM/yyyy'}}</td>
                <td><span><a [class.linea-texto]="canje.medico.usuario.activo==0"
                            [routerLink]="['/administrador/medico', canje.medico.id]">{{canje.medico.nom_medico
                            |
                            uppercase}}</a></span></td>
                <td><span
                        [ngClass]="{'solicitud': canje.status === 1,'enproceso': canje.status === 2, 'pagado': canje.status === 3, 'cancelado': canje.status === 4}">{{getCanje(canje.status)}}</span>
                </td>
                <td>{{canje.redimir}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">Sin canjes</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="currentPage.first" [rows]="currentPage.rows"
            [totalRecords]="totalItems"></p-paginator>

    </div>
</section>